import { baseURL, moduleName } from "../../../controllers/api/globalEndpoint.api";

const companyInformationEndPoint = {
    getCompanyInformation: baseURL + moduleName.auth + moduleName.chatbot + '/company-instruction',
    updateCompanyInformation: baseURL + moduleName.auth + moduleName.chatbot + '/update-company-instruction',
};

export default companyInformationEndPoint;